/* eslint-disable */
/*
ajax请求函数模块
返回值: promise对象(异步返回的数据是: response.data)
 */
import axios from 'axios'
import store from '../store'
import { setToken, getToken, getUUID, removeUUID, removeToken, removeLoginPhone } from '@/common/auth'
import {
  SET_TOKEN
} from '@/store/mutation-types'

// 请求拦截器
axios.interceptors.request.use(config => {
  // console.log('in request: ', config)

  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  // 设置uuid
  config.headers['uuid'] = getUUID()
  // console.log('in ajax.js request， uuid = ', getUUID())

  return config
}, error => {
  return Promise.reject(error);
})

// 响应拦截器
axios.interceptors.response.use(response => {
  // console.log('in response', response)

  //token 过期，获取刷新后的access-token
  const token = response.headers['authorization']
  if (token) {
    setToken(token)
    store.commit(SET_TOKEN, {token})
  }

  return response;
}, error => {
  // console.log('in response error', error);

  if(error.response.status === 401) {
    // 401 说明 token 验证失败
    // 可以直接跳转到登录页面，重新登录获取 token
    removeToken()
    removeLoginPhone()
    removeUUID()
    // location.href = '/login'
  } else if(error.response.status === 403) {
    // 403 说明 账号多处登录
    // 清空本地token, 可以直接跳转到登录页面，重新登录获取 token
    removeToken()
    removeLoginPhone()
    removeUUID()
  } else if (error.response.status === 500) {
    // 服务器错误
    // do something
    return Promise.reject(error.response.data)
  }
  // 返回接口返回的错误信息
  return Promise.reject(error.response.data);
})

export default function ajax (url, data={}, type='GET', config={}) {
  return new Promise(function (resolve, reject) {
    // 执行异步ajax请求
    let promise
    if (type === 'GET') {
      // 准备url query参数数据
      let dataStr = '' // 数据拼接字符串
      Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&'
      })
      if (dataStr !== '') {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
        url = url + '?' + dataStr
      }
      // 发送get请求
      if (!config) {
        promise = axios.get(url)
      } else {
        promise = axios.get(url, config)
      }

    } else {
      // 发送post请求
      if (!config) {
        promise = axios.post(url, data)
      } else {
        promise = axios.post(url, data, config)
      }
    }
    promise.then(function (response) {
      // 成功了调用resolve()
      resolve(response.data)
    }).catch(function (error) {
      // 失败了调用reject()
      if(error.code === 401) {
        // 401 说明 账号多处登录
        // 清空本地token, 可以直接跳转到登录页面，重新登录获取 token
        // console.log('in ajax response 403', error)
        alert(error.message)
        location.href = '/login'
        return
      } else if(error.code === 403) {
        // 403 说明 账号多处登录
        // 清空本地token, 可以直接跳转到登录页面，重新登录获取 token
        // console.log('in ajax response 403', error)
        alert(error.message)
        location.href = '/login'
        return
      }
      alert("系统出现异常，请稍后再试。")
      reject(error)
    })
  })
}
// export default function ajax (url, data={}, type = 'GET') {
//
//   return new Promise(function (resolve, reject) {
//     // 执行异步ajax请求
//     let promise
//     if (type === 'GET') {
//       // 准备url query参数数据
//       let dataStr = '' // 数据拼接字符串
//       Object.keys(data).forEach(key => {
//         dataStr += key + '=' + data[key] + '&'
//       })
//       if (dataStr !== '') {
//         dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
//         url = url + '?' + dataStr
//       }
//       console.log(url);
//       // 发送get请求
//       promise = axios.get(url)
//     } else {
//       // 发送post请求
//       promise = axios.post(url, data)
//     }
//     promise.then(function (response) {
//       // 成功了调用resolve()
//       resolve(response.data)
//     }).catch(function (error) {
//       // 失败了调用reject()
//       reject(error)
//     })
//   })
// }



// WEBPACK FOOTER //
// ./src/api/ajax.js